import axios from "utils/axios";

const URL = "/uaapi/uaa/";

//获取二维码
export function get_qr(config) {
  return axios.get(URL + `authorize/token/qr`, config);
}

//获取二维码
export function get_qrResult(config) {
  return axios.get(URL + `authorize/token/qrResult`, config);
}

//获取密码公钥
export function post_passwdPublicKey(config) {
  return axios.post(URL + `authorize/passwd/publicKey`, null, config);
}

//设置安全密码
export function post_tokenSetSafePwd(config) {
  return axios.post(URL + `authorize/token/setSafePwd`, null, config);
}

//登录前置校验通过后下返回2fa验证项以及优先级
export function post_loginByFaBeforeCheck(config) {
  return axios.post(URL + `authorize/v2/loginByFaBeforeCheck`, null, config);
}

//通过2fa凭证登录
export function get_loginBy2Fa(faResultId, config) {
  return axios.get(URL + `authorize/loginBy2Fa/${faResultId}`, config);
}

//接口授权页面使用
export function get_oauth2Authorize(config) {
  return axios.get(URL + `oauth2/authorize`, config);
}
